import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckCircleIcon, MapPinIcon, RocketIcon, LockIcon, StarIcon, AlertCircleIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
export function CoursesHero() {
  const {
    isAuthenticated
  } = useAuth();
  const benefits = ['Se deblochează onboardingul de agent', 'Poți continua traseul pentru a deveni Agent CLC', 'Primești acces la etapele următoare din program'];
  return <div className="relative bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white overflow-hidden" data-id="element-842">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-843">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] bg-repeat" data-id="element-844"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32" data-id="element-845">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-846">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-left" data-id="element-847">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/20" data-id="element-848">
              <MapPinIcon className="w-4 h-4 text-[#357BEB]" data-id="element-849" />
              <span className="text-sm font-medium text-white" data-id="element-850">
                Start Point
              </span>
            </motion.div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-851">
              Totul începe cu <br data-id="element-852" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#357BEB] to-[#21A366]" data-id="element-853">
                Training 1
              </span>
            </h1>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed max-w-xl" data-id="element-854">
              Începe călătoria ta spre a deveni Agent CLC. Primul pas în
              ecosistemul CautLocuință.ro este{' '}
              <span className="font-semibold text-white" data-id="element-855">
                Training 1 – Concept CLC
              </span>
              .
            </p>

            {/* Access Information Banner */}
            {!isAuthenticated && <div className="bg-amber-500/20 backdrop-blur-sm rounded-2xl p-5 border border-amber-400/30 mb-6" data-id="element-856">
                <div className="flex items-start space-x-3" data-id="element-857">
                  <AlertCircleIcon className="w-5 h-5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-858" />
                  <div data-id="element-859">
                    <h3 className="font-bold text-white mb-2" data-id="element-860">
                      Acces training-uri
                    </h3>
                    <ul className="text-sm text-gray-200 space-y-1.5" data-id="element-861">
                      <li data-id="element-862">
                        • <strong data-id="element-863">Fără logare:</strong> Niciun training nu este
                        disponibil
                      </li>
                      <li data-id="element-864">
                        • <strong data-id="element-865">După logare:</strong> Doar primele 2
                        training-uri sunt disponibile
                      </li>
                      <li data-id="element-866">
                        • <strong data-id="element-867">Training-uri 3-10:</strong> Se deblochează
                        după finalizarea onboarding-ului
                      </li>
                    </ul>
                  </div>
                </div>
              </div>}

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 mb-8" data-id="element-868">
              <div className="flex items-start space-x-3 mb-4" data-id="element-869">
                <div className="bg-[#357BEB] p-2 rounded-lg" data-id="element-870">
                  <LockIcon className="w-5 h-5 text-white" data-id="element-871" />
                </div>
                <div data-id="element-872">
                  <h3 className="font-bold text-lg mb-1" data-id="element-873">Important</h3>
                  <p className="text-sm text-gray-300" data-id="element-874">
                    Finalizarea Training 1 este obligatorie pentru a debloca
                    onboardingul și accesul în agenția CLC.
                  </p>
                </div>
              </div>

              <ul className="space-y-3" data-id="element-875">
                {benefits.map((benefit, index) => <li key={index} className="flex items-center space-x-3" data-id="element-876">
                    <CheckCircleIcon className="w-5 h-5 text-[#21A366] flex-shrink-0" data-id="element-877" />
                    <span className="text-gray-300 text-sm sm:text-base" data-id="element-878">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-879">
              {!isAuthenticated ? <Link to="/auth/login" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-2xl text-white bg-gradient-to-r from-[#357BEB] to-[#21A366] hover:shadow-lg hover:scale-105 transition-all duration-300 group" data-id="element-880">
                  <span data-id="element-881">Loghează-te pentru acces</span>
                  <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-882" />
                </Link> : <Link to="/curs/concept-clc" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-2xl text-white bg-gradient-to-r from-[#357BEB] to-[#21A366] hover:shadow-lg hover:scale-105 transition-all duration-300 group" data-id="element-883">
                  <span data-id="element-884">Începe Training 1</span>
                  <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-885" />
                </Link>}
            </div>
          </motion.div>

          {/* Right Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-886">
            <div className="relative z-10 bg-white rounded-3xl p-2 shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-887">
              <div className="bg-gray-50 rounded-2xl overflow-hidden border border-gray-100" data-id="element-888">
                <div className="bg-[#132C53] p-6 text-white flex justify-between items-center" data-id="element-889">
                  <div data-id="element-890">
                    <div className="text-xs font-bold text-[#357BEB] uppercase tracking-wider mb-1" data-id="element-891">
                      Training 1
                    </div>
                    <h3 className="text-2xl font-bold" data-id="element-892">Concept CLC</h3>
                  </div>
                  <div className="w-12 h-12 bg-[#357BEB] rounded-full flex items-center justify-center" data-id="element-893">
                    <RocketIcon className="w-6 h-6 text-white" data-id="element-894" />
                  </div>
                </div>
                <div className="p-8 space-y-6" data-id="element-895">
                  <div className="flex items-center space-x-4" data-id="element-896">
                    <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center font-bold text-[#357BEB]" data-id="element-897">
                      1
                    </div>
                    <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-898">
                      <div className="w-0 h-full bg-[#357BEB]" data-id="element-899"></div>
                    </div>
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 text-xs" data-id="element-900">
                      2
                    </div>
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 text-xs" data-id="element-901">
                      3
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-902">
                    <div className="h-4 bg-gray-200 rounded w-3/4" data-id="element-903"></div>
                    <div className="h-4 bg-gray-200 rounded w-full" data-id="element-904"></div>
                    <div className="h-4 bg-gray-200 rounded w-5/6" data-id="element-905"></div>
                  </div>
                  <div className="pt-4 border-t border-gray-100 flex justify-between items-center" data-id="element-906">
                    <span className="text-sm text-gray-500" data-id="element-907">
                      Durata: ~45 min
                    </span>
                    <span className="text-sm font-bold text-[#21A366]" data-id="element-908">
                      Gratuit
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Elements behind */}
            <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#357BEB] rounded-full blur-3xl opacity-30" data-id="element-909"></div>
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#21A366] rounded-full blur-3xl opacity-30" data-id="element-910"></div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none" data-id="element-911">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" data-id="element-912"></svg>
      </div>
    </div>;
}